const API_BASE_URL = process.env.VUE_APP_API_URL;
const ENABLE_MOBILE_SITE = process.env.VUE_APP_ENABLE_MOBILE_SITE;

export default {
  API_BASE_URL: API_BASE_URL,
  ENABLE_MOBILE_SITE: ENABLE_MOBILE_SITE,
};
